import React, { useState, useRef, useEffect } from 'react'
import css from './ModalFirma.module.css'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

const ModalFirma = ({ open, onClose, onSubmit }) => {

  const [isFirma, setIsFirma] = useState(false)

  const [isDrawing, setIsDrawing] = useState(false)
  const canvasRef = useRef(null)

  const setCanvasSize = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.width = canvas.clientWidth;
      canvas.height = canvas.clientHeight;
    }
  };

  const onReset = () => {
    const context = canvasRef.current?.getContext('2d')
    if (!context) return
    context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height)
    setIsFirma(false)
  }

  const onAccept = () => {
    if (!canvasRef || !canvasRef.current) return
    const dataUrl = canvasRef.current.toDataURL('image/png')
    onSubmit(dataUrl)
  }

  const startDrawing = (e) => {
    setIsDrawing(true)
    draw(e)
  }

  const startTouchDrawing = (e) => {
    e.preventDefault()
    startDrawing(e.touches[0])
  }

  const endDrawing = () => {
    const context = canvasRef.current?.getContext('2d')
    setIsDrawing(false)
    if (context) context.beginPath()
  }

  const endTouchDrawing = (e) => {
    e.preventDefault()
    endDrawing()
  }

  const draw = (e) => {
    if (!isDrawing) return
    const context = canvasRef.current?.getContext('2d')
    const rect = canvasRef.current.getBoundingClientRect()
    context.lineWidth = 2
    context.lineCap = 'round'
    context.strokeStyle = 'black'

    context.lineTo(e.clientX - rect.left, e.clientY - rect.top)
    context.stroke()
    context.beginPath()
    context.moveTo(e.clientX - rect.left, e.clientY - rect.top)
    if (!isFirma) setIsFirma(true)
  }

  const touchDraw = (e) => {
    e.preventDefault()
    draw(e.touches[0])
  }
  useEffect(() => {
    if (!open) return
    setCanvasSize(); // Set initial size
    const handleResize = () => setCanvasSize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [open]);

  if (!open) return null

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>
        Firma
      </DialogTitle>
      <DialogContent>
        <canvas
          ref={canvasRef}
          className={css.canvas}
          onTouchStart={startTouchDrawing}
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onTouchMove={touchDraw}
          onMouseUp={endDrawing}
          onMouseOut={endDrawing}
          onTouchEnd={endTouchDrawing}
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onReset}>Borrar firma</Button>
        <Button disabled={!isFirma} onClick={onAccept}>
          Guardar firma
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalFirma
